import { useEffect, useState } from "react";
import { api, resolveImg } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Star, Clock, MapPin } from "lucide-react";
import { fmtRON } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const HERO = "https://images.unsplash.com/photo-1444201306876-5df1e6fdb65a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900";

export default function Experiences() {
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/experiences").then(({ data }) => setExperiences(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="App">
      <Navbar />
      <section className="relative h-[360px]">
        <img src={HERO} alt="Experiențe montane" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/45" />
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="max-w-xl animate-fade-up">
              <p className="overline text-white/80 mb-3">Ghizi locali · Grupuri mici</p>
              <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight">
                Experiențe Montane în România
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-96 rounded-2xl" />)}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {experiences.map((exp, i) => (
              <div key={exp.id} data-testid={`experience-card-${exp.id}`}
                   className="card-hover rounded-2xl overflow-hidden bg-card border border-border/60 animate-fade-up"
                   style={{ animationDelay: `${i * 80}ms` }}>
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={resolveImg(exp.image)} alt={exp.title} className="h-full w-full object-cover" />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-sm text-muted-foreground mb-2">
                    <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {exp.region}</span>
                    <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {exp.duration}</span>
                  </div>
                  <h3 className="font-medium text-lg leading-snug">{exp.title}</h3>
                  <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{exp.description}</p>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-border/60">
                    <span className="flex items-center gap-1 text-sm">
                      <Star className="h-4 w-4 fill-[hsl(var(--amber))] text-[hsl(var(--amber))]" />
                      {exp.rating} <span className="text-muted-foreground">({exp.review_count})</span>
                    </span>
                    <span className="text-sm"><span className="font-semibold">{fmtRON(exp.price_per_person)}</span> / pers.</span>
                  </div>
                  <Button onClick={() => toast.success("Rezervare experiență — în curând disponibilă!")}
                          data-testid={`book-experience-${exp.id}`}
                          className="w-full mt-4 bg-primary hover:bg-primary/90 rounded-full">
                    Rezervă locul
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
